import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function PreviousQuitAttemptsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.previousQuitAttempts.heading')}
      buttons={[
        {
          text: t('pages.onboarding.previousQuitAttempts.options.first-time'),
          value: 'first-time',
        },
        {
          text: t('pages.onboarding.previousQuitAttempts.options.once'),
          value: 'once',
        },
        {
          text: t('pages.onboarding.previousQuitAttempts.options.few-times'),
          value: 'few-times',
        },
        {
          text: t('pages.onboarding.previousQuitAttempts.options.many-times'),
          value: 'many-times',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
